<script setup>
import { rebateList } from '~/apis/referral'
import { time2Date } from '#imports'
import NoData from '@/components/common/NoData.vue'
import TimeSelector from './TimeSelector.vue'

const { t } = useI18n()
const inviteList = ref([])
const times = ref()
const loading = ref(false)

const tmpFields = [
  {
    label: t('返佣时间'),
    key: 'invitationTime',
    format: item => time2Date(item.invitationTime, 'y-m-d h:i:s'),
  },
  { label: t('好友账号'), key: 'friendAccount' },
  { label: t('返佣类型'), key: 'type', format: ({ type }) => {
    const map = {
      1: t('现货交易'),
      2: t('合约交易'),
    }
    return map[type]
  } },
  { label: t('返佣数量'), key: 'number', format: item => `${item.number} ${item.currencyCode.toUpperCase() || ''}` },
]

async function getRebateList() {
  loading.value = true
  const params = times.value
    ? { startTime: times.value[0], endTime: times.value[1] }
    : {}

  const res = await rebateList({ ...params, page: 1, pageSize: 100 })
  if (res.success) {
    inviteList.value = res.data
  }
  loading.value = false
}

watch(times, () => {
  getRebateList()
}, { immediate: true })
</script>

<template>
  <div class="flex gap-3 flex-col">
    <TimeSelector
      v-model:times="times"
      v-model:select-day="selectDay"
      @change="getInviteList"
    />
    <xDate v-model:show="pickerVisible" :single="false" @change="handleChangeTime" />
    <div v-if="loading" class="flex items-center justify-center h-100 py-6">
      <CommonIconsLoading class="w-10 h-10" />
    </div>
    <template v-else-if="inviteList.length">
      <div v-for="(item, index) in inviteList" :key="index" class="flex flex-col gap-2 pb-2  px-4" :class="{ 'border-b border-dividerPrimary': index !== inviteList.length - 1 }">
        <div v-for="field in tmpFields" :key="field.key" class="flex items-center justify-between ">
          <div class="text-xs text-textTertiary">
            {{ $t(field.label) }}
          </div>
          <div class="text-xs text-textPrimary">
            {{ field.format ? field.format(item) : item[field.key] }}
          </div>
        </div>
      </div>
    </template>
    <div v-else>
      <NoData />
    </div>
  </div>
</template>
